var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandingNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 52.25V49.0833C23.75 47.4036 24.4173 45.7927 25.605 44.605C26.7927 43.4173 28.4036 42.75 30.0833 42.75H36.4167C38.0964 42.75 39.7073 43.4173 40.895 44.605C42.0827 45.7927 42.75 47.4036 42.75 49.0833V52.25M44.3333 23.9558C45.6957 24.3046 46.9031 25.0969 47.7654 26.2078C48.6277 27.3187 49.0958 28.685 49.0958 30.0913C49.0958 31.4975 48.6277 32.8638 47.7654 33.9747C46.9031 35.0856 45.6957 35.8779 44.3333 36.2267M52.25 52.25V49.0833C52.242 47.6855 51.7717 46.3296 50.9125 45.227C50.0533 44.1243 48.8535 43.3369 47.5 42.9875M26.9167 30.0833C26.9167 31.763 27.5839 33.3739 28.7717 34.5617C29.9594 35.7494 31.5703 36.4167 33.25 36.4167C34.9297 36.4167 36.5406 35.7494 37.7283 34.5617C38.9161 33.3739 39.5833 31.763 39.5833 30.0833C39.5833 28.4036 38.9161 26.7927 37.7283 25.605C36.5406 24.4173 34.9297 23.75 33.25 23.75C31.5703 23.75 29.9594 24.4173 28.7717 25.605C27.5839 26.7927 26.9167 28.4036 26.9167 30.0833Z",
    stroke: "url(#paint0_linear_2774_10346)",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2774_10346",
    x1: 23.75,
    y1: 38,
    x2: 52.25,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandingNetwork);
export default __webpack_public_path__ + "static/media/Expanding Network.2f1fd6cce04814d43fa646f8d9bbe458.svg";
export { ForwardRef as ReactComponent };